export var IdAssetBundlePier;
(function (IdAssetBundlePier) {
    IdAssetBundlePier["Pier_1"] = "Pier_1";
})(IdAssetBundlePier || (IdAssetBundlePier = {}));



//////////////////
// WEBPACK FOOTER
// ./src/assetBundles/outskirts/IdAssetBundlePier.ts
// module id = 2142
// module chunks = 3